import { render } from "./DangerZoneUser.vue?vue&type=template&id=2eb1edfc"
import script from "./DangerZoneUser.vue?vue&type=script&lang=js"
export * from "./DangerZoneUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__